/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import Datetime from 'react-datetime';

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSCheckBox from "components/Forms/TSCheckBox";
import TSSelect2 from "components/Forms/TSSelect2";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";

import TSUser from "components/Forms/TSUser";
// import avatar from "assets/img/faces/marc.jpg";
import {
    Input,
    Label,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }]

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

// ย้าย moment มาไว้ข้างนอกเพื่อแก้ปัญหา dependency
var moment = require('moment');
require('moment/locale/th');

const MyLeave = (props) => {
    // ลบการประกาศ moment ในนี้ออก
    const [leaveAll, setLeaveAll] = useState([]);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    const [LeaveTypeKey, setLeaveTypeKey] = useState(0);
    const [ArrLeave, setArrLeave] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [modal, setModal] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [optionYear, setOptionYear] = useState([]);
    const [year, setYear] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    // const [isShowCalendar, setIsShowCalendar] = useState(false);

    const myRef = useRef(null);
    var calendarRef = React.createRef();

    useEffect(() => {

        var startYear = parseInt(moment().format("BBBB"));
        if (isNaN(startYear)) {
            startYear = parseInt(moment().format("YYYY")) + 543;
        }
        if (moment().month() >= 9) {
            startYear = startYear + 1;
        }
        setYear(startYear);

        // แก้ไข: สร้าง array ชั่วคราวแทนการ push ใส่ state โดยตรง
        let tempOptionYear = [];
        for (var i = startYear + 1; i > startYear - 10; i--) {
            tempOptionYear.push({ value: i, label: i });
        }
        setOptionYear(tempOptionYear);


        axios("/api/v1/leave/leavetypeall")
            .then(
                result => {
                    var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"leaveTypeKey":').join('"value":'));
                    setArrLeave(json)
                    getMeeting(startYear)
                }, error => { console.log(error); }
            );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        setIsLoading(true);

        if (year > 0) {
            // แก้ไข: รวม string "/api/v1/leave/myheader/" กับ "?Calyear="
            axios.get("/api/v1/leave/myheader/?Calyear=" + year + "&LeaveTypeKey=" + LeaveTypeKey)
                .then(
                    result => {
                        var json = JSON.parse(JSON.stringify(result.data).split('"leaveDesc":').join('"title":').split('"startDate":').join('"start":')
                            .split('"endDate":').join('"end":').split('"leaveRequestID":').join('"id":'));
                        if (json.length >= 0) {
                            setLeaveAll(json);
                            console.log(json);
                            setIsLoading(false);
                        }
                    },
                    error => { alert(error); }
                );
        }

    }, [LeaveTypeKey, year]);



    const getMeeting = (startYear) => {
        setIsLoading(true);
        // แก้ไข: รวม string "/api/v1/leave/myheader/" กับ "?Calyear="
        axios.get("/api/v1/leave/myheader/?Calyear=" + startYear)
            .then(
                result => {

                    var json = JSON.parse(JSON.stringify(result.data).split('"leaveDesc":').join('"title":').split('"startDate":').join('"start":')
                        .split('"endDate":').join('"end":').split('"leaveRequestID":').join('"id":'));
                    if (json.length >= 0) {
                        setLeaveAll(json);
                        setIsLoading(false);
                    }

                },
                error => { alert(error); }
            );
    }

    const handleConfirm = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    };


    const handleDateClick = (args) => {
        setDefaultDate(args.dateStr);

    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))

    };


    const handleEventClickList = e => {
        // แก้ไข: != เป็น !==
        if (e.event._def.publicId !== null && e.event._def.publicId !== '') {
            props.history.push({
                pathname: 'id/' + e.event._def.publicId,
                //state: {
                //    meetingID: e.event._def.publicId
                //}
            })
        }

    }


    const classes = useStyles();
    return (

        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={6} sm={6} md={3}>
                                    <h4 className={classes.cardTitleWhite}>ปฏิทินการลาของฉัน</h4>
                                </Col>

                                <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                                    {/* {isShowCalendar ? */}
                                    <TSSelect2
                                        options={optionYear}
                                        onChange={e => setYear(e.value)}
                                        value={year}
                                    //defaulfAdd={optionYear[0]}
                                    />
                                    <TSSelect2 label="" options={ArrLeave} value={LeaveTypeKey} onChange={e => setLeaveTypeKey(e.value)} />
                                    {/* : <></>
                                    } */}
                                </Col>
                                {/* <Col xs={6} sm={6} md={3} style={{ textAlign: 'right' }}>
                                    <TSCheckBox checked={isShowCalendar} onChange={e => setIsShowCalendar(!isShowCalendar)} /> {(isShowCalendar) ? <span style={{ color: 'white' }} >แยกห้อง </span> : <span style={{ color: 'white' }}>รายการ </span>}
                                </Col> */}
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            {/* {(!isShowCalendar) ?
                                <Grid>
                                    <Col xs={12} sm={6} md={7}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title", // will normally be on the left. if RTL, will be on the right
                                                    center: "",
                                                    end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                                }}
                                                hiddenDays={[0, 6]}
                                                height={"100vh"}
                                                dateClick={handleDateClick}
                                                events={leaveAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                //editable={true}
                                                //eventClick={}
                                                eventClick={handleEventClick}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6} md={5}>
                                        <Fullcalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                                            initialView={"listWeek"}
                                            headerToolbar={{
                                                start: "listWeek,listMonth", // will normally be on the left. if RTL, will be on the right
                                                center: "title",
                                                end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                            }}
                                            views={{
                                                listDay: { buttonText: 'วัน' },
                                                listWeek: { buttonText: 'สัปดาห์' },
                                                listMonth: { buttonText: 'เดือน' }
                                            }}
                                            hiddenDays={[0, 6]}
                                            height={"100vh"}
                                            //dateClick={handleDateClick}
                                            events={leaveAll}
                                            droppable={true}
                                            rerenderDelay={10}
                                            eventDurationEditable={false}
                                            eventClick={handleEventClickList}
                                            locale={'th'}
                                            eventContent={renderEventContent2}
                                        />
                                    </Col>
                                </Grid>
                                : */}
                            <Grid>
                                {isLoading && (
                                    <>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <img style={{ width: "50%" }} src={loading} alt="..." />
                                        </Col>
                                    </>
                                )}
                                {!isLoading && (<>
                                    <Col xs={12} sm={12} md={5}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title", // will normally be on the left. if RTL, will be on the right
                                                    center: "",
                                                    end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                                }}
                                                hiddenDays={[0, 6]}
                                                //height={"100vh"}
                                                dateClick={handleDateClick}
                                                events={leaveAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                //editable={true}
                                                //eventClick={}
                                                eventClick={handleEventClick}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                                displayEventTime={false}
                                            />
                                        </div>
                                    </Col>
                                    {(leaveAll.length > 0) && (
                                        <Col xs={12} sm={12} md={7} style={{ marginTop: "20px" }}>
                                            <div >
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>วันที่</th>
                                                            <th>รายละเอียด</th>
                                                            <th>จำนวนวัน</th>
                                                            <th>สถานะ</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {

                                                            leaveAll.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td style={{ minWidth: '70px' }}>
                                                                        {moment(item.start).format('D MMM BB')}
                                                                    </td>
                                                                    <td>
                                                                        <a href={"id/" + item.id} >{item.title}</a>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {item.totalDate} {item.isApprove}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        {/* แก้ไข: == เป็น === */}
                                                                        {(item.isApprove === 1) ? <i class="fa fa-check" style={{ color: 'green' }} aria-hidden="true" /> : <></>}
                                                                        {(item.approveStatusKey === 1) ? <i class="fa fa-question" style={{ color: item.color }} aria-hidden="true" /> : <></>}
                                                                        {(item.approveStatusKey === -1) ? <i class="fa fa-close" style={{ color: item.color }} aria-hidden="true" /> : <></>}
                                                                    </td>
                                                                    {/* <td>
                                <input
                                    name="position"
                                    type="text"
                                    value={position}
                                    onChange={(e) => onChangeInput(e, employeeId)}
                                    placeholder="Type Position"
                                />
                                </td> */}
                                                                </tr>
                                                            ))}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>)}
                                </>)
                                }
                            </Grid>


                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );


    function renderEventContent(eventInfo) {

        const _c = _color.find(c => c.id === eventInfo.event.extendedProps.leaveTypeKey);
        const _room = ArrLeave.find(c => c.value === eventInfo.event.extendedProps.leaveTypeKey);
        const roomTxt = (_room !== undefined) ? _room.label : '';
        // แก้ไข: == เป็น ===
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isCancel === true) ? 'red' : _c.forecolor) : '#000000';

        // แก้ไข: == เป็น ===
        const strikeTxt = (eventInfo.event.extendedProps.isCancel === true) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-time" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.timeText}</div>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}>{roomTxt} {eventInfo.event.title}</div>
            </>
        )
    }

    function renderEventContent2(eventInfo) {

        const _c = _color.find(c => c.id === eventInfo.event.extendedProps.leaveTypeKey);
        const _room = ArrLeave.find(c => c.value === eventInfo.event.extendedProps.leaveTypeKey);

        // แก้ไข: == เป็น ===
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isCancel === true) ? 'red' : _c.forecolor) : '#000000';
        const roomTxt = (_room !== undefined) ? _room.label : '';
        // แก้ไข: == เป็น ===
        const strikeTxt = (eventInfo.event.extendedProps.isCancel === true) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}>{roomTxt} {eventInfo.event.title} </div>
            </>
        )
    }
}

export default MyLeave;
